<span *ngIf="visible">{{value}}</span>  